import { render, staticRenderFns } from "./UsersMaintenanceCustomPermissionsComponent.vue?vue&type=template&id=4eafa9ab&scoped=true&lang=pug"
import script from "./UsersMaintenanceCustomPermissionsComponent.vue?vue&type=script&lang=ts"
export * from "./UsersMaintenanceCustomPermissionsComponent.vue?vue&type=script&lang=ts"
import style0 from "./UsersMaintenanceCustomPermissionsComponent.vue?vue&type=style&index=0&id=4eafa9ab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eafa9ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eafa9ab')) {
      api.createRecord('4eafa9ab', component.options)
    } else {
      api.reload('4eafa9ab', component.options)
    }
    module.hot.accept("./UsersMaintenanceCustomPermissionsComponent.vue?vue&type=template&id=4eafa9ab&scoped=true&lang=pug", function () {
      api.rerender('4eafa9ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/maintenance/Users/components/UsersMaintenanceCustomPermissionsComponent.vue"
export default component.exports